import React from 'react';
import { Anchor, Avatar, Box, ResponsiveContext, Text } from 'grommet';
import { Waypoint } from 'react-waypoint';
import { useHomeContext } from '../contexts/HomeContext';

export const ContributorsColumn = (datum: any) => (
  <ResponsiveContext.Consumer>
    {(size) => {
      const isMobile = size === 'xsmall' || size === 'small';
      const sliceAmount = isMobile ? 3 : 8;
      const contributors = datum.contributors.slice(0, sliceAmount);
      const remain = datum.contributors.length - sliceAmount;
      return (
        <Box pad={{ vertical: 'xsmall' }} direction="row" gap="small">
          {contributors.length > 0 ? (
            contributors.map((contributor: any, i: number) => {
              return (
                <Box key={i}>
                  {isMobile ? (
                    <Anchor
                      href={contributor.url}
                      target="_blank"
                      rel="noopener"
                    >
                      <Avatar size="small" src={contributor.avatarUrl} />
                    </Anchor>
                  ) : (
                    <Anchor
                      href={`/${contributor.username}/repos`}
                      target="_blank"
                      rel="noopener"
                    >
                      <Avatar src={contributor.avatarUrl} />
                    </Anchor>
                  )}
                </Box>
              );
            })
          ) : (
            <Text>
              <b>None</b>
            </Text>
          )}
          {remain > 0 && (
            <Text alignSelf="center">
              <b>+{remain}</b>
            </Text>
          )}
        </Box>
      );
    }}
  </ResponsiveContext.Consumer>
);

export const RepositoryColumn = (datum: any) => {
  const { state, fetchMore } = useHomeContext();
  return (
    <Anchor color="dark-2" href={`/${datum.name}/contributors`}>
      <Text>{datum.name}</Text>
      {datum.i + 1 === state.repos.length - 2 && (
        <Waypoint onEnter={fetchMore} />
      )}
    </Anchor>
  );
};
